<template>
  <div class="home h-100">
    <!-- Navigation -->
    <PostCareerNavbar />
    <section class="hero-header">
      <div class="container">
            <div class="row back-wrapper">
              <div class="col-12">
                <div class="backBtn-wrapper">
                  <a @click="$router.push({ name: 'Blog'})" href="#" class="btn">
                    <span class="fas fa-arrow-left"></span>
                    <span class="ml-2 back">Back to Blog</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="blog-post-wrapper">
                <div class="overlay"></div>
                <picture>
                  <source media="(max-width: 400px)" srcset="/img/blog-post-image-mobile.jpg">
                  <source media="(min-width: 768px)" srcset="/img/blog-post-image2.png">
                  <img src="/img/blog-post-image2.png" alt="" class="img-fluid">
                </picture>
                <!-- <img 
                  srcset="/img/blog-post-image-mobile.png 360w, /img/blog-post-image2.png 1121w" 
                  sizes="(max-width: 575px) 360px, 1121px" 
                  src="/img/blog-post-image2.png" 
                  alt="" 
                  class="img-fluid"
                > -->
            </div>
        </div>
    </section>

    <section class="article">
      <div class="container">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <div>
            <h3>Facts About Dividends You Need to Know</h3>
            <div class="d-flex align-items-center date-wrap">
              <img src="img/avartar2.svg" alt="">
              <small class="date ml-2">By Admin on 22 December, 2019</small>
            </div>
            <div class="article-text">
              <p>As the year 2020 draws near, most companies will be paying dividends in the first to the second quarter of the year. To maximize the benefit of dividends as a recipient, you need to understand all there is to the payment of dividends.</p>
              <p>
                To start with, what are dividends? Dividends are one way in which companies “share the wealth” generated from the business. They are usually paid in cash, often drawn from earnings paid to investors of a company – shareholders. These are paid on an annual or commonly, quarterly basis.
              </p>
            </div>
            <blockquote>
              “ Investors should become familiar with all four steps before buying a dividend stock, as being able to identify these dates will help avoid any potential confusion. “
            </blockquote>
            <div>
              <p><strong>There are four steps to this process that often go unnoticed by dividend investors</strong></p>
              <ul>
                <li>Declaration date</li>
                <li>Ex-Dividend date</li>
                <li>Record date</li>
                <li>Payment date</li>
              </ul>
              <p>Investors should become familiar with all four steps before buying a dividend stock, as being able to identify these dates will help avoid any potential confusion.</p>
              
            </div>
            <div>
              <p><strong>Step #1</strong>First, the company declares its dividend payment. This is the dividend declaration date.</p>
              <p><strong>Step #2</strong>: Second, a company decides which shareholders will receive a dividend. Shareholders who own shares before the ex-dividend date will receive the next dividend payment.</p>
              <p>Important Note: The ex-dividend date is two days before the record date.</p>
              <p><strong>Step #3</strong>: Third, the record date is the date when the corporation looks at its records to determine who will receive the dividend.</p>
              <p><strong>Step #3</strong>: Third, the record date is the date when the corporation looks at its records to determine who will receive the dividend.</p>
              <p><strong>Step #4</strong>: Finally, the ex-dividend date is the payment date, when the dividend is paid to shareholders.</p>
              <p>What matters for shareholders is receiving the dividend in question. And these important dates determine who receive the dividend and who does not.</p>
              <p>For Investments advice and services, Loan Facilities or BDC needs. We will be willing to help you. You can send us a mail at info@coralstone.capital or call us on 08169352843.</p>

            </div>
            <hr>
            <div>
              <span class="mr-3">Tags:</span>
              <span class="badge badge-pill badge-secondary mr-3">finance advices</span>
              <span class="badge badge-pill badge-secondary mr-3">Money Hack</span>
            </div>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer"
import PostCareerNavbar from "../components/PostCareerNavbar.vue";

export default {
  name: 'Home',
  components: {
    PostCareerNavbar,
    Footer
  },
  
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/colors.scss";

  // hero header styles
  .hero-header {
      padding-top: 6rem;

      .blog-post-wrapper {
          margin-top: 1rem;
          position: relative;

          .overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            background: linear-gradient(180deg, #2B3990 0%, #94248C 100%);
            mix-blend-mode: multiply;
            opacity: 0.85;
            border-radius: 8px;
          }
      }

      .back {
        font-family: Source Sans Pro;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 20px;
        color: #2C3C90;
      }
  }

  // blog article styles
  .article {
    padding: 3rem 0 6rem;

    p {
      font-size: 16px;
      line-height: 19px;
      letter-spacing: 0.02em;
      color: #0D0D26
    }

    h3 {
      font-weight: bold;
      font-size: 32px;
      line-height: 48px;
      letter-spacing: 0.02em;
      color: #171F4A;
    }

    .article-text {
      margin-top: 2rem;
    }

    blockquote {
      background: #FFFFFF;
      border-left: 3px solid #94248C;
      padding: 1rem;
      font-family: Poppins;
      font-style: italic;
      font-weight: 500;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0.02em;
      color: #2C3C90
    }

    hr {
      margin: 1.5rem 0;
    }

    .badge-secondary {
      background: #D8DCF3;
      color: #000;
    }
  }

  
  @media (min-width: 992px) and (max-width: 1199px) {
    .hero-header {
        padding-top: 5.5rem;

    }
    .article {

      h3 {
        font-size: 30px;
      }
    }
  }

  @media (min-width: 767px) and (max-width: 991px) {
    .hero-header {
        padding-top: 6rem;

    }
    .article {

      h3 {
        font-size: 23px;
      }

      blockquote {
        font-size: 18px;
      }
    }
  }

  @media (max-width: 767px) {
    .hero-header {
        padding-top: 6rem;

    }
    .article {

      h3 {
        font-size: 32px;
        line-height: 38px;
      }
    }
  }

  



</style>

